import { registerMutation } from 'data-fetching-client';
import { getQualityClient } from 'marketplace-ui-common/clients/qualityClient';

export const REPORT_REVIEW = registerMutation({
  fieldName: 'reportReviewResponse',
  args: ['reviewId', 'reportReason', 'comment'],
  fetcher({
    reviewId,
    reportReason,
    comment,
  }: {
    reviewId: string | number;
    replyId?: string | number;
    reportReason: string;
    comment: string;
  }) {
    return getQualityClient('app').post(`/reviews/${reviewId}/report`, {
      data: {
        reportReason,
        comment,
      },
    });
  },
});
